// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d14f0235","703":"4a01edae"}[chunkId] + ".chunk.js";
};